import safariThumb from "../assets/safari-banner.jpg"; 
import garafiThumb from "../assets/girafe.jpg";
import leopardThumb from '../assets/Leopaed.jpg';
import PrideInnThumb from '../assets/PrideInn.jpg'
import beachThumb from "../assets/beach.jpg";
import heinoThumb from "../assets/heino.jpg";
import slavaThumb from "../assets/slava.jpg";

export const safariTrips = [
  {
    id: 1,
    title: "10 Days Uganda Gorillas and Northern Tanzania Circuit Safari",
    typeOfSafari: [
      "Primates",
      "Boat ride",
      "Birdwatching",
      "Gorilla trekking",
      "Wildlife Safari",
      "Nature",
    ],
    destination:"Uganda",
    startLocation: "Entebbe International Airport",
    endLocation: "Entebbe International Airport",
    description:
      "This safari offers signature East African attractions. Experience chimpanzees, gorillas, boat rides, birdlife, and iconic game drives. Journey through Uganda and Tanzania, crossing the Equator twice and visiting national parks including Kibale, Queen Elizabeth, Bwindi, Lake Manyara, and Ngorongoro.",
    itinerary: [
      {
        day: 1,
        location: "Entebbe International Airport",
        activity: "Arrival, welcome and trip briefing",
        accommodation: "Bed & Breakfast (BB)",
        details:
          "Welcome to Uganda. You'll be met at Entebbe International Airport, transferred to your hotel, and briefed about your upcoming safari.",
      },
      {
        day: 2,
        location: "To Kibale National Park",
        activity: "Afternoon bird watching in Bigodi Wetland",
        accommodation: "Full Board",
        details:
          "Drive west to Kibale National Park via Fort Portal. After lunch, enjoy a guided birdwatching walk in the Bigodi Wetland community.",
      },
      {
        day: 3,
        location: "Kibale NP / Queen Elizabeth NP",
        activity: "Chimpanzee tracking and boat ride on Kazinga Channel",
        accommodation: "Full Board",
        details:
          "Track chimpanzees in Kibale forest in the morning. In the afternoon, transfer to Queen Elizabeth NP for a scenic boat ride on the Kazinga Channel.",
      },
      {
        day: 4,
        location: "Queen Elizabeth NP to Bwindi",
        activity: "Game drive in Kasenyi and drive through Ishasha",
        accommodation: "Full Board",
        details:
          "Morning game drive in Kasenyi plains, then drive through Ishasha where you may spot tree-climbing lions. Proceed to Bwindi.",
      },
      {
        day: 5,
        location: "Bwindi Impenetrable Forest",
        activity: "Gorilla trekking",
        accommodation: "Full Board",
        details:
          "Early morning trek into the forest for a face-to-face encounter with a mountain gorilla group. Optional transfer to Lake Bunyonyi in the evening.",
      },
      {
        day: 6,
        location: "Return to Entebbe",
        activity: "Drive through Kigezi and Ankole, cultural stop",
        accommodation: "Full Board",
        details:
          "Full-day drive back to Entebbe with scenic views and a cultural stop at Igongo Centre and the Equator crossing.",
      },
      {
        day: 7,
        location: "Flight to Arusha, Tanzania",
        activity: "Fly to Kilimanjaro International Airport and transfer to Arusha",
        accommodation: "Bed & Breakfast (BB)",
        details:
          "Fly to Tanzania. Upon arrival at Kilimanjaro Airport, transfer to a hotel in Arusha for rest and city views.",
      },
      {
        day: 8,
        location: "Lake Manyara National Park",
        activity: "Big 5 game drive",
        accommodation: "Full Board",
        details:
          "Game drive in Lake Manyara NP, home to diverse habitats and tree-climbing lions. Picnic lunch in the wild.",
      },
      {
        day: 9,
        location: "Ngorongoro Conservation Area",
        activity: "Crater game drive",
        accommodation: "Full Board",
        details:
          "Descend into the Ngorongoro Crater for a full-day wildlife experience. Spot rhinos, flamingos, hyenas, and more. Lunch by the hippo pool.",
      },
      {
        day: 10,
        location: "Ngorongoro – Arusha – Entebbe",
        activity: "End of safari and flight back to Entebbe",
        accommodation: "Lunch Only",
        details:
          "Drive back to Arusha and fly to Entebbe, marking the end of your 10-day Uganda-Tanzania safari.",
      },
    ],
    image: safariThumb,
  },
  {
    id: 2,
    title: "12 Days Source of Nile, Gorilla, Ngorongoro and Zanzibar Circuit Safari",
    typeOfSafari: ["Wildlife", "Cultural", "Beach", "Adventure"],
    startLocation: "Entebbe International Airport",
    endLocation: "Zanzibar Airport",
    description:
      "Explore East Africa with a combination of gorilla trekking, the Ngorongoro crater, and the beaches of Zanzibar on this incredible 12-day adventure.",
    itinerary: [
      {
        day: 1,
        location: "Entebbe International Airport",
        activity: "Arrival and hotel transfer",
        accommodation: "Bed & Breakfast (BB)",
        details:
          "Arrival at Entebbe and transfer to your hotel. Briefing about the exciting safari ahead.",
      },
      {
        day: 2,
        location: "Kibale National Park",
        activity: "Chimpanzee tracking",
        accommodation: "Full Board",
        details:
          "Drive to Kibale National Park for chimpanzee trekking and explore the Bigodi Wetland Sanctuary in the afternoon.",
      },
      {
        day: 3,
        location: "Bwindi Impenetrable Forest",
        activity: "Drive and relax at Bwindi",
        accommodation: "Full Board",
        details:
          "Transfer to Bwindi Impenetrable Forest, with stops including the equator line and scenic drives through Queen Elizabeth NP.",
      },
      {
        day: 4,
        location: "Bwindi",
        activity: "Gorilla trekking",
        accommodation: "Full Board",
        details:
          "Spend the day trekking mountain gorillas in the forest with expert guides.",
      },
      {
        day: 5,
        location: "Lake Bunyonyi",
        activity: "Relax and enjoy the lake",
        accommodation: "Full Board",
        details:
          "Transfer to Lake Bunyonyi for relaxation and beautiful views.",
      },
      {
        day: 6,
        location: "Return to Kampala",
        activity: "Drive and cultural visit",
        accommodation: "Bed & Breakfast (BB)",
        details:
          "Drive back to Kampala via Igongo Cultural Centre and the Equator, with a brief museum visit.",
      },
      {
        day: 7,
        location: "Fly to Arusha",
        activity: "Flight and hotel transfer",
        accommodation: "Bed & Breakfast (BB)",
        details:
          "Fly from Entebbe to Kilimanjaro Airport and transfer to hotel in Arusha.",
      },
      {
        day: 8,
        location: "Ngorongoro Conservation Area",
        activity: "Game drive in Ngorongoro Crater",
        accommodation: "Full Board",
        details:
          "Descend into the Ngorongoro Crater for wildlife viewing including the Big 5.",
      },
      {
        day: 9,
        location: "Arusha – Zanzibar",
        activity: "Fly to Zanzibar and Stone Town tour",
        accommodation: "Half Board (HB)",
        details:
          "Fly to Zanzibar and explore Stone Town's rich culture and history.",
      },
      {
        day: 10,
        location: "Zanzibar",
        activity: "Spice tour and Prison Island visit",
        accommodation: "Full Board",
        details:
          "Explore Zanzibar’s famous spice plantations and visit Prison Island to see giant tortoises.",
      },
      {
        day: 11,
        location: "Zanzibar Beach",
        activity: "Relax on the beach or optional water activities",
        accommodation: "Full Board",
        details:
          "Free day to enjoy the beaches of Zanzibar, snorkel, dive, or relax.",
      },
      {
        day: 12,
        location: "Zanzibar",
        activity: "Departure",
        accommodation: "Breakfast Only",
        details:
          "Relax in the morning before your flight departure from Zanzibar Airport.",
      },
    ],
    image: garafiThumb,
  },
    {
    id: 3,
  title: "5 Days Kenya Standard Tour",
  typeOfSafari: [
    "Wildlife Safari",
    "Big Five",
    "Birdwatching",
    "Nature",
    "Cultural Experience",
    "Game Drives",
  ],
  startLocation: "Nairobi",
  endLocation: "Nairobi",
  description:
    "Explore Kenya's wildlife and natural wonders on this 5-day safari through Nairobi, Lake Nakuru, and Maasai Mara. Witness the Big Five, flamingos, rhinos, and experience iconic African landscapes, ending your journey back in Nairobi.",
  itinerary: [
    {
      day: 1,
      location: "Nairobi",
      activity: "Arrival and trip briefing",
      accommodation: "La Maison Royale / Swiss Lenana Mount Hotel",
      details:
        "Upon arrival at Nairobi Airport, meet your guide and regional manager for a short safari briefing before transfer to your city hotel.",
    },
    {
      day: 2,
      location: "Lake Nakuru National Park",
      activity: "Scenic drive, lunch, and afternoon game drive",
      accommodation: "Flamingo Hill Camp / Ziwa Bush Lodge",
      details:
        "After breakfast, drive to Lake Nakuru, known for flamingos and rich wildlife. Enjoy lunch, then head out for an afternoon game drive.",
    },
    {
      day: 3,
      location: "Maasai Mara National Reserve",
      activity: "Scenic drive and evening game drive",
      accommodation: "Mara Sopa Lodge / Mara Leisure Camp",
      details:
        "Drive through the Great Rift Valley to Maasai Mara. Arrive in time for lunch, then embark on an evening game drive till late.",
    },
    {
      day: 4,
      location: "Inside Maasai Mara",
      activity: "Morning and evening game drives",
      accommodation: "Mara Sopa Lodge / Mara Leisure Camp",
      details:
        "Enjoy early morning and evening game drives in one of Africa’s top wildlife reserves. Midday is for leisure and rest at the lodge.",
    },
    {
      day: 5,
      location: "Maasai Mara to Nairobi",
      activity: "Optional game drive and return to Nairobi",
      accommodation: "None",
      details:
        "Optional early morning game drive followed by breakfast. Drive back to Nairobi and transfer to airport for departure.",
    },
  ],
  image: leopardThumb, // Replace with actual image import or URL
},
{
id: 4,
  title: "7 Days Standard Kenya Tour",
  typeOfSafari: [
    "Wildlife Safari",
    "Big Five",
    "Birdwatching",
    "Nature",
    "Cultural Experience",
    "Game Drives",
  ],
  startLocation: "Nairobi",
  endLocation: "Nairobi",
  description:
    "A 7-day classic safari adventure through Kenya's top destinations: Amboseli National Park with its dramatic views of Mt. Kilimanjaro, the peaceful Lake Naivasha, and the wildlife-rich Maasai Mara. This itinerary offers rich wildlife encounters, local culture, and iconic African scenery.",
  itinerary: [
    {
      day: 1,
      location: "Nairobi",
      activity: "Arrival and trip briefing",
      accommodation: "La Maison Royale Nairobi",
      details:
        "Upon arrival at Nairobi airport, meet your guide and regional manager for a safari briefing, then transfer to your hotel for rest and overnight. Meal Plan: Bed & Breakfast.",
    },
    {
      day: 2,
      location: "Amboseli National Park",
      activity: "Scenic drive, lunch, and game drive",
      accommodation: "Amboseli Sopa Lodges",
      details:
        "Drive to Amboseli National Park at the base of Mt. Kilimanjaro. Arrive for lunch, followed by an afternoon game drive. Meal Plan: Full Board.",
    },
    {
      day: 3,
      location: "Amboseli National Park",
      activity: "Full day game drives",
      accommodation: "Amboseli Sopa Lodges",
      details:
        "Spend the day on full-day game drives in Amboseli, famous for its elephant herds and views of Mt. Kilimanjaro. All meals at the lodge. Meal Plan: Full Board.",
    },
    {
      day: 4,
      location: "Lake Naivasha",
      activity: "Travel and optional boat ride or Crescent Island walk",
      accommodation: "Lake Naivasha Country Club",
      details:
        "After breakfast, travel to Lake Naivasha. Arrive for lunch and rest. Optional activities include a boat ride or Crescent Island nature walk. Meal Plan: Full Board.",
    },
    {
      day: 5,
      location: "Maasai Mara National Reserve",
      activity: "Travel and evening game drive",
      accommodation: "La Maison Mara Camp",
      details:
        "Drive to the Maasai Mara. Arrive in time for lunch. Enjoy an evening game drive to explore this iconic park. Meal Plan: Full Board.",
    },
    {
      day: 6,
      location: "Inside Maasai Mara",
      activity: "Morning and evening game drives",
      accommodation: "La Maison Mara Camp",
      details:
        "Early morning and evening game drives with time to relax midday. Spot lions, elephants, and more in this rich ecosystem. Meal Plan: Full Board.",
    },
    {
      day: 7,
      location: "Maasai Mara – Nairobi",
      activity: "Return to Nairobi and depart",
      accommodation: "None",
      details:
        "Optional early game drive, followed by breakfast. Drive back to Nairobi. Lunch is at your own expense. Transfer to the airport for departure. Meal Plan: Breakfast only.",
    },
  ],
  pricing: [
    {
      period: "All Year",
      prices: {
        "Per Person (Twin/Double Sharing)": 1396,
      },
    },
  ],
  includes: [
    "Transport in a safari mini bus",
    "Transport to and from the airport",
    "Accommodation on Full Board in the bush and BB in Nairobi",
    "Park entry fees",
    "Services of a professional English speaking guide",
    "6 breakfasts, 5 lunches, 5 dinners",
  ],
  excludes: [
    "International Flights",
    "Visa and Visa fees",
    "Tips and gratuities",
    "Items of personal use",
    "Optional activities (e.g. Maasai Village visit, Balloon ride)",
    "4×4 Land Cruiser upgrade (US$240 per cruiser/day, max 6 pax)",
  ],
  optionalAddons: [
    { name: "Maasai Village Visit", priceUSD: 30, perPerson: true },
    { name: "Balloon Ride", priceUSD: 450, perPerson: true },
    { name: "4×4 Land Cruiser Upgrade", priceUSD: 240, perDay: true },
  ],
  image: PrideInnThumb,
},
{
  id: 5,
  title: "13 Days Uganda Primates & Kenya Jumbo Safari",
  typeOfSafari: [
    "Primates",
    "Gorilla Trekking",
    "Wildlife Safari",
    "Cultural Experience",
    "Birdwatching",
    "Nature",
    "Game Drives",
  ],
  startLocation: "Entebbe International Airport",
  endLocation: "Entebbe International Airport",
  description:
    "This 13-day cross-border safari blends Uganda’s rich primate tracking with Kenya’s iconic big game experiences. Track chimpanzees in Kibale, come face-to-face with gorillas in Bwindi, and then hop over to Kenya for scenic flights, African elephants, Maasai culture, and the legendary Maasai Mara plains.",
  countries: ["Uganda", "Kenya"],
  itinerary: [
    {
      day: 1,
      location: "Entebbe",
      activity: "Arrival and trip briefing",
      accommodation: "Skyz Hotel by Mattiot / Latitude Zero Hotel",
      details:
        "Arrive in Entebbe where your guide will meet and brief you on the safari. Transfer to your hotel for overnight.",
    },
    {
      day: 2,
      location: "Kibale National Park",
      activity: "Drive to Kibale and chimpanzee tracking",
      accommodation: "Primates Lodge / Chimps Nest Lodge / Kikorongo Safari Lodge",
      details:
        "Drive west to Kibale NP, known as the world’s primate capital. In the afternoon, go chimpanzee tracking through the tropical forest.",
    },
    {
      day: 3,
      location: "Bwindi Impenetrable National Park",
      activity: "Drive through Queen Elizabeth NP and Ishasha sector",
      accommodation: "Mahogany Springs / Ruhija Lodge",
      details:
        "Travel to Bwindi via Queen Elizabeth NP. Stop at the Equator monument and pass through the Ishasha sector, home of tree-climbing lions.",
    },
    {
      day: 4,
      location: "Bwindi to Lake Bunyonyi",
      activity: "Gorilla tracking and scenic transfer",
      accommodation: "Arcadia Safari Lodge / Keije Bunyonyi Lodge",
      details:
        "Early breakfast and gorilla trek (3-7 hours depending on location of gorillas). After your trek, transfer to Lake Bunyonyi for overnight.",
    },
    {
      day: 5,
      location: "Entebbe to Nairobi",
      activity: "Return drive to Entebbe and evening flight to Kenya",
      accommodation: "Fairmont The Norfolk / Nairobi Safari Club",
      details:
        "Drive back to Entebbe for a flight to Nairobi. On arrival, you'll be welcomed and transferred to your hotel.",
    },
    {
      day: 6,
      location: "Amboseli National Park",
      activity: "Fly to Amboseli and game drive",
      accommodation: "Oltukai Lodge / Amboseli Serena Safari Lodge",
      details:
        "Fly from Nairobi to Amboseli. Enjoy a game drive en route to your camp, set beneath Mt. Kilimanjaro.",
    },
    {
      day: 7,
      location: "Amboseli National Park",
      activity: "Full-day game drives with Kilimanjaro views",
      accommodation: "Oltukai Lodge / Amboseli Serena Safari Lodge",
      details:
        "Morning and afternoon game drives in Amboseli. Watch elephants and wildlife with views of Africa’s highest mountain. Optional sundowner.",
    },
    {
      day: 8,
      location: "Lake Naivasha & Hell’s Gate",
      activity: "Fly to Nairobi, drive to Lake Naivasha & visit Hell’s Gate",
      accommodation: "Enashipai Resort / Great Rift Valley Lodge",
      details:
        "Fly back to Nairobi then drive to Lake Naivasha. Explore Hell’s Gate National Park on foot or bicycle.",
    },
    {
      day: 9,
      location: "Maasai Mara National Reserve",
      activity: "Drive to Maasai Mara, afternoon game drive",
      accommodation: "Keekorok Lodge / Mara Serena Safari Lodge",
      details:
        "Drive to the world-famous Maasai Mara. Arrive in time for lunch, followed by an afternoon game drive.",
    },
    {
      day: 10,
      location: "Inside Maasai Mara",
      activity: "Morning and afternoon game drives",
      accommodation: "Keekorok Lodge / Mara Serena Safari Lodge",
      details:
        "Early game drive, relax mid-morning, and another drive in the afternoon. Optional: Hot air balloon ride followed by bush breakfast.",
    },
    {
      day: 11,
      location: "Inside Maasai Mara",
      activity: "Full-day safari and optional activities",
      accommodation: "Keekorok Lodge / Mara Serena Safari Lodge",
      details:
        "Continue your exploration of Maasai Mara with another full day of game viewing. Balloon safari option available.",
    },
    {
      day: 12,
      location: "Maasai Mara – Nairobi – Entebbe",
      activity: "Return to Nairobi, lunch at Carnivore, flight to Entebbe",
      accommodation: "None",
      details:
        "After a morning game drive and breakfast, return to Nairobi for lunch at the Carnivore Restaurant. Fly back to Entebbe in the evening.",
    },
    {
      day: 13,
      location: "Departure",
      activity: "End of safari",
      accommodation: "None",
      details:
        "Your journey concludes with your international departure from Entebbe. Thank you for traveling with us.",
    },
  ],
  includes: [
    "4x4 Land Cruiser transport",
    "Flights: Nairobi–Amboseli–Nairobi",
    "Accommodation on Full Board on safari and BB in Nairobi",
    "Airport transfers",
    "All park/conservancy entry fees",
    "Professional English-speaking safari guide",
    "Lunch at Carnivore Restaurant",
  ],
  excludes: [
    "Gorilla permit (US$700)",
    "Chimpanzee tracking (US$200)",
    "International flights",
    "Visa and visa fees",
    "Tips and gratuities",
    "Items of personal nature",
    "Balloon ride (US$500 per person)",
    "Optional: Mini-van reduction (US$700)",
  ],
  optionalAddons: [
    { name: "Gorilla Trekking Permit", priceUSD: 700, perPerson: true },
    { name: "Chimpanzee Tracking", priceUSD: 200, perPerson: true },
    { name: "Balloon Ride (Maasai Mara)", priceUSD: 500, perPerson: true },
    { name: "Mini Van Transport Option", priceUSD: -700, perSafari: true },
  ],
  image: safariThumb, // Replace with actual image file or path
},
{
  id: 6,
  title: "9 Days Kenya Bush and Beach",
  typeOfSafari: [
    "Beach Safari",
    "Game Drives",
    "Big Five",
    "Relaxation",
    "Cultural Experience",
    "Nature",
  ],
  startLocation: "Nairobi",
  endLocation: "Mombasa / Nairobi (by flight)",
  description:
    "This 9-day safari combines the thrill of Kenya’s rugged wilderness with the tranquility of its beautiful coastline. Start in Tsavo West, known for its lava flows and rich wildlife, then unwind at the white-sand beaches of Mombasa. Ideal for couples, honeymooners, or families seeking adventure and relaxation.",
  countries: ["Kenya"],
  itinerary: [
    {
      day: 1,
      location: "Nairobi",
      activity: "Arrival and trip briefing",
      accommodation: "Nairobi Serena Hotel / Crowne Plaza",
      mealPlan: "Bed & Breakfast",
      details:
        "Meet and greet at Nairobi airport followed by a short briefing and transfer to your hotel to relax after your journey.",
    },
    {
      day: 2,
      location: "Tsavo West National Park",
      activity: "Drive to Tsavo West and afternoon game drive",
      accommodation: "Sarova Salt Lick Lodge / Voyager Ziwani",
      mealPlan: "Full Board",
      details:
        "Travel to Tsavo West, a beautiful wilderness park famous for Mzima Springs, Shetani Lava flows, and dramatic landscapes. Afternoon game drive.",
    },
    {
      day: 3,
      location: "Tsavo West National Park",
      activity: "Full-day game drives",
      accommodation: "Sarova Salt Lick Lodge / Voyager Ziwani",
      mealPlan: "Full Board",
      details:
        "Spend the day exploring Tsavo’s rugged savannah and tracking wildlife like elephants, lions, hippos, and leopards.",
    },
    {
      day: 4,
      location: "Mombasa (Coast)",
      activity: "Drive to the coast and begin beach relaxation",
      accommodation: "Voyager Beach Resort / Whitesands Beach Hotel",
      mealPlan: "All Inclusive",
      details:
        "After breakfast, drive to Mombasa (~5 hours). Arrive in time for lunch and relax on the Indian Ocean coast.",
    },
    {
      day: 5,
      location: "Mombasa",
      activity: "Beach time & optional excursions",
      accommodation: "Voyager Beach Resort / Whitesands Beach Hotel",
      mealPlan: "All Inclusive",
      details:
        "Relax at the beach or choose from excursions such as Fort Jesus, Mamba Village, Shimba Hills, or dolphin watching.",
    },
    {
      day: 6,
      location: "Mombasa",
      activity: "Free day at the beach",
      accommodation: "Voyager Beach Resort / Whitesands Beach Hotel",
      mealPlan: "All Inclusive",
      details:
        "Enjoy another full day soaking in the sun or take part in water activities like snorkeling or dhow cruises.",
    },
    {
      day: 7,
      location: "Mombasa",
      activity: "Optional tours or relaxation",
      accommodation: "Voyager Beach Resort / Whitesands Beach Hotel",
      mealPlan: "All Inclusive",
      details:
        "You can opt for more excursions, nature trails, or spa treatments — or simply relax by the sea.",
    },
    {
      day: 8,
      location: "Mombasa",
      activity: "Last full day at the coast",
      accommodation: "Voyager Beach Resort / Whitesands Beach Hotel",
      mealPlan: "All Inclusive",
      details:
        "Final full day to enjoy the coast, with meals included. Optional final activities or gift shopping.",
    },
    {
      day: 9,
      location: "Mombasa – Moi International Airport – Nairobi (flight)",
      activity: "Transfer to airport and fly back to Nairobi",
      accommodation: "None",
      mealPlan: "Breakfast",
      details:
        "After breakfast, you’ll be transferred to Mombasa Airport for a flight to Nairobi, where you’ll connect to your international departure.",
    },
  ],
  includes: [
    "Transport in a safari mini-bus",
    "Airport transfers (arrival and departure)",
    "Accommodation as per itinerary",
    "All park entry fees",
    "One-way flight from Mombasa to Nairobi",
    "Professional English-speaking guide",
  ],
  excludes: [
    "International flights",
    "Visa and visa fees",
    "Tips and gratuities",
    "Items of personal nature",
    "Excursions in Mombasa (available on request)",
    "4×4 Land Cruiser upgrade (US$240 per day, max 6 pax)",
  ],
  optionalAddons: [
    { name: "4×4 Land Cruiser Upgrade", priceUSD: 240, perDay: true },
    {
      name: "Mombasa Excursions (Fort Jesus, Dolphin Tour, etc.)",
      priceUSD: null,
      perPerson: true,
      availableOnRequest: true,
    },
  ],
  seasonalPricing: [
    {
      season: "3rd Jan – 31st Mar",
      prices: {
        single: 2741,
        double: 2312,
        fourPax: 1980,
        sixPax: 1926,
        singleRoomSupplement: 485,
      },
    },
    {
      season: "1st Apr – 30th Jun",
      prices: {
        single: 2497,
        double: 2168,
        fourPax: 1655,
        sixPax: 1582,
        singleRoomSupplement: 343,
      },
    },
    {
      season: "1st Jul – 31st Oct",
      prices: {
        single: 2705,
        double: 2374,
        fourPax: 1860,
        sixPax: 1790,
        singleRoomSupplement: 511,
      },
    },
    {
      season: "1st Nov – 22nd Dec",
      prices: {
        single: 2641,
        double: 2212,
        fourPax: 1780,
        sixPax: 1726,
        singleRoomSupplement: 485,
      },
    },
    {
      season: "23rd Dec – 2nd Jan",
      prices: {
        single: 2705,
        double: 2574,
        fourPax: 2260,
        sixPax: 2190,
        singleRoomSupplement: 511,
      },
    },
  ],
  image: safariThumb,
},
 {
  id: 7,
  title: "Best of Kenya and Uganda Luxury Safari",
  typeOfSafari: [
    "Luxury Safari",
    "Gorilla Trekking",
    "Chimpanzee Tracking",
    "Game Drives",
    "Primates",
    "Birdwatching",
    "Boat Safari",
    "Big Five",
    "Cultural Experience",
  ],
  startLocation: "Nairobi, Kenya",
  endLocation: "Entebbe, Uganda",
  description:
    "An unforgettable 12-day journey through Kenya and Uganda, combining classic game drives in iconic Kenyan reserves with up-close primate encounters in Uganda. From the Big Five of the Maasai Mara to the endangered mountain gorillas of Bwindi, this is an extraordinary cross-border safari for wildlife lovers.",
  countries: ["Kenya", "Uganda"],
  itinerary: [
    {
      day: 1,
      location: "Nairobi",
      activity: "Arrival and rest",
      accommodation: "Tamarind Tree Hotel",
      mealPlan: "Bed & Breakfast",
      details:
        "Arrival at Jomo Kenyatta International Airport and transfer to your hotel. Remainder of the day at leisure.",
    },
    {
      day: 2,
      location: "Ol Pejeta Conservancy",
      activity: "Chimpanzee Sanctuary & game viewing",
      accommodation: "Sweetwaters Tented Camp",
      mealPlan: "Full Board",
      details:
        "Drive to Ol Pejeta Conservancy. Visit the Chimpanzee Sanctuary and the black rhino refuge. Optional night drives or camel trekking.",
    },
    {
      day: 3,
      location: "Lake Nakuru National Park",
      activity: "Game drives & flamingo viewing",
      accommodation: "Flamingo Hill Camp",
      mealPlan: "Full Board",
      details:
        "Travel to Lake Nakuru, famous for its flamingo-covered shores and rhino population. Afternoon game drive.",
    },
    {
      day: 4,
      location: "Maasai Mara National Reserve",
      activity: "Game drive in the Mara",
      accommodation: "Keekorok Lodge",
      mealPlan: "Full Board",
      details:
        "Drive to the world-famous Maasai Mara. Afternoon game drive to spot the Big Five and experience the savannah.",
    },
    {
      day: 5,
      location: "Maasai Mara National Reserve",
      activity: "Full day safari",
      accommodation: "Keekorok Lodge",
      mealPlan: "Full Board",
      details:
        "Morning and afternoon game drives in the Mara. Option for a full-day drive with picnic lunch.",
    },
    {
      day: 6,
      location: "Nairobi / Entebbe (flight)",
      activity: "Return to Nairobi and fly to Uganda",
      accommodation: "The Source of Nile Hotel",
      mealPlan: "Full Board",
      details:
        "Early morning game drive, then return to Nairobi and fly to Entebbe, Uganda. Welcome and transfer to hotel.",
    },
    {
      day: 7,
      location: "Kibale National Park",
      activity: "Scenic drive and Bigodi wetland walk",
      accommodation: "Primates Lodge",
      mealPlan: "Full Board",
      details:
        "Drive to Kibale with lunch en route. Afternoon walk in Bigodi Wetland to spot monkeys, birds, and support community tourism.",
    },
    {
      day: 8,
      location: "Kibale / Queen Elizabeth National Park",
      activity: "Chimp tracking and boat safari",
      accommodation: "Kikorongo Safari Lodge",
      mealPlan: "Full Board",
      details:
        "Trek wild chimpanzees in Kibale. After lunch, drive to Queen Elizabeth NP for a sunset boat ride along the Kazinga Channel.",
    },
    {
      day: 9,
      location: "Queen Elizabeth / Bwindi",
      activity: "Game drive and transfer to Bwindi",
      accommodation: "Mahogany Lodge",
      mealPlan: "Full Board",
      details:
        "Early morning game drive in the Kasenyi plains. Transfer through Ishasha (tree-climbing lions) to Bwindi.",
    },
    {
      day: 10,
      location: "Bwindi / Lake Bunyonyi",
      activity: "Gorilla trekking and transfer to Lake Bunyonyi",
      accommodation: "Arcadia Lodge",
      mealPlan: "Full Board",
      details:
        "Early morning gorilla trek in Bwindi. After your encounter, travel to Lake Bunyonyi for relaxation on the island.",
    },
    {
      day: 11,
      location: "Lake Bunyonyi / Entebbe",
      activity: "Scenic transfer with stops",
      accommodation: "Protea Hotel Entebbe",
      mealPlan: "Full Board",
      details:
        "Drive to Entebbe via Igongo Cultural Centre and the Equator crossing. Enjoy views of the highlands and Ankole cattle.",
    },
    {
      day: 12,
      location: "Departure from Entebbe",
      activity: "Airport transfer for international flight",
      accommodation: null,
      mealPlan: null,
      details:
        "Relax before your international flight. Optional hotel extension available.",
    },
  ],
  includes: [
    "Meet and greet with airport assistance",
    "All ground transport in safari minivan (private basis)",
    "Domestic flight from Nairobi to Entebbe",
    "Services of English-speaking guides",
    "Game drives and park entry fees",
    "Chimpanzee permit (Kibale)",
    "Gorilla permit (Bwindi)",
    "Accommodation as listed",
    "All meals as per itinerary",
  ],
  excludes: [
    "International flights",
    "Visa and visa fees (Kenya and Uganda)",
    "Tips and gratuities",
    "Personal expenses",
    "Holiday surcharges (Christmas, Easter, etc.)",
    "Beach extension (available on request)",
  ],
  optionalAddons: [
    {
      name: "Beach Extension (Mombasa or Diani)",
      priceUSD: null,
      availableOnRequest: true,
    },
    {
      name: "Balloon Safari (Masai Mara)",
      priceUSD: null,
      availableOnRequest: true,
    },
  ],
  seasonalPricing: [
    {
      season: "Peak Season",
      dates: "1 Jul – 31 Oct, 22 Dec – 1 Jan",
    },
    {
      season: "High Season",
      dates: "2 Jan – 31 Mar, 16 Jun – 30 Jun, 1 Nov – 21 Dec",
    },
    {
      season: "Low Season",
      dates: "1 Apr – 31 May",
    },
  ],
  childPolicy: {
    ageRange: "3–11 years",
    discount: "50% of adult rate",
  },
  notes: [
    "Gorilla trekking requires good fitness. Porters are available.",
    "Gorilla & chimp permits are limited; early booking recommended.",
    "Holiday surcharge not included but can be provided on request.",
    "This tour crosses the equator twice — a fun photo op!",
  ],
  image: safariThumb, // Replace with actual image
},
 {
  id: 8,
  title: "12 Days Uganda Primates and Wildlife Safari",
  typeOfSafari: [
    "Primates",
    "Gorilla Trekking",
    "Chimpanzee Tracking",
    "Game Drives",
    "Boat Safari",
    "White Water Rafting",
    "Cultural Experience",
    "Birdwatching",
  ],
  startLocation: "Entebbe, Uganda",
  endLocation: "Entebbe, Uganda",
  price: {
    original: 4200,
    discounted: 3950,
    currency: "USD",
  },
  description:
    "This 12-day safari takes you deep into the heart of Uganda for unforgettable encounters with gorillas, chimpanzees, and other wildlife. Experience game drives, boat safaris, crater lakes, and cultural moments. From the powerful Murchison Falls to white-water rafting on the Nile, this adventure offers Uganda’s wild beauty in full color.",
  countries: ["Uganda"],
  itinerary: [
    {
      day: 1,
      location: "Entebbe / Kampala",
      activity: "Arrival and transfer to Kampala",
      accommodation: "Hotel in Kampala",
      mealPlan: "Dinner",
      details:
        "Arrive at Entebbe International Airport and transfer to your hotel in Kampala. Enjoy views of Lake Victoria and relax ahead of your adventure.",
    },
    {
      day: 2,
      location: "Ziwa Rhino Sanctuary / Murchison Falls",
      activity: "Rhino tracking and top of the falls visit",
      accommodation: {
        upmarket: "Paraa Safari Lodge",
        midrange: "Murchison River Lodge",
        budget: "Heritage Lodge",
      },
      mealPlan: "Lunch, Dinner",
      details:
        "Track rhinos at Ziwa Rhino Sanctuary. Continue to Murchison Falls National Park and visit the top of the falls for breathtaking views of the Nile.",
    },
    {
      day: 3,
      location: "Murchison Falls NP",
      activity: "Game drive and boat cruise",
      accommodation: "Same as Day 2",
      mealPlan: "Breakfast, Lunch, Dinner",
      details:
        "Morning game drive on the northern bank of the Nile. Afternoon boat cruise to the base of Murchison Falls. Spot elephants, giraffes, crocodiles, hippos, and more.",
    },
    {
      day: 4,
      location: "Kibale Forest National Park",
      activity: "Scenic transfer to Kibale, the primate capital",
      accommodation: {
        upmarket: "Papaya Lake Lodge",
        midrange: "Primate Lodge",
        budget: "Chimpanzee Guest House",
      },
      mealPlan: "Breakfast, Lunch, Dinner",
      details:
        "Drive through scenic countryside and crater lakes to Kibale. Arrive in the evening and prepare for chimpanzee trekking.",
    },
    {
      day: 5,
      location: "Kibale Forest",
      activity: "Chimpanzee tracking and Bigodi Wetland walk",
      accommodation: "Same as Day 4",
      mealPlan: "Breakfast, Lunch, Dinner",
      details:
        "Track wild chimpanzees in Kibale Forest. Later visit Bigodi Wetland for community-based tourism and birdwatching.",
    },
    {
      day: 6,
      location: "Queen Elizabeth National Park",
      activity: "Transfer and boat safari on Kazinga Channel",
      accommodation: {
  upmarket: "Paraa Safari Lodge",
  midrange: "Murchison River Lodge",
  budget: "Heritage Lodge",
},

      mealPlan: "Breakfast, Lunch, Dinner",
      details:
        "Transfer to Queen Elizabeth NP via crater lake route. Enjoy a boat safari along Kazinga Channel with abundant wildlife and birdlife.",
    },
    {
      day: 7,
      location: "Queen Elizabeth NP / Ishasha Sector",
      activity: "Game drive and search for tree-climbing lions",
      accommodation: {
        upmarket: "Ishasha Wilderness Camp",
        midrange: "Destination Jungle Lodge",
        budget: "Enjonjo Lodge",
      },
      mealPlan: "Breakfast, Lunch, Dinner",
      details:
        "Game drive in Kasenyi Plains, then head to the Ishasha sector to search for the iconic tree-climbing lions.",
    },
    {
      day: 8,
      location: "Bwindi Impenetrable Forest",
      activity: "Transfer through scenic highlands",
      accommodation: {
        upmarket: "Buhoma Lodge",
        midrange: "Buhoma Haven Lodge",
        budget: "Buhoma Community Rest Camp",
      },
      mealPlan: "Breakfast, Lunch, Dinner",
      details:
        "Travel through the Kigezi Highlands to Bwindi. Settle in and prepare for your gorilla tracking experience.",
    },
    {
      day: 9,
      location: "Bwindi Impenetrable Forest",
      activity: "Gorilla trekking",
      accommodation: "Same as Day 8",
      mealPlan: "Breakfast, Lunch, Dinner",
      details:
        "Track mountain gorillas in Bwindi. Spend one unforgettable hour observing them in the wild. Optional: village walk or visit to Lake Bunyonyi.",
    },
    {
      day: 10,
      location: "Lake Mburo National Park",
      activity: "Scenic drive and afternoon boat safari",
      accommodation: {
        upmarket: "Mihingo Lodge",
        midrange: "Rwakobo Rock",
        budget: "Eagle's Nest",
      },
      mealPlan: "Breakfast, Lunch, Dinner",
      details:
        "Drive to Lake Mburo via cultural museum stop. Take a relaxing boat ride in the park on arrival.",
    },
    {
      day: 11,
      location: "Lake Mburo / Kampala / Jinja",
      activity: "Game drive and transfer to Jinja via Equator stop",
      accommodation: {
        upmarket: "Wildwaters Lodge",
        midrange: "Haven Lodge",
        budget: "Nile River Camp",
      },
      mealPlan: "Breakfast, Lunch, Dinner",
      details:
        "Morning game drive in Lake Mburo NP. Stop at the Equator for photos. Continue to Jinja, Uganda’s adventure capital.",
    },
    {
      day: 12,
      location: "Jinja",
      activity: "White-water rafting on the Nile",
      accommodation: null,
      mealPlan: "Breakfast, Lunch",
      details:
        "Full-day white-water rafting at the Source of the Nile. Optional activities: quad biking, bungee jumping, or horseback safaris. Transfer to Kampala or Entebbe.",
    },
  ],
  includes: [
    "Ground transport in safari vehicle",
    "Gorilla trekking permit",
    "Chimpanzee tracking permit",
    "National park entrance fees",
    "Boat cruises",
    "White-water rafting",
    "Bottled water in the safari vehicle",
    "Full board accommodation",
    "English-speaking driver/guide",
    "All listed activities (except optional ones)",
  ],
  excludes: [
    "International flights",
    "Tips to guides, porters, and hotel staff",
    "Travel insurance",
    "Optional activities (bungee jumping, quad biking, etc.)",
    "Personal expenses (laundry, drinks, phone calls, etc.)",
  ],
  notes: [
    "Gorilla trekking requires good fitness and hiking boots.",
    "Porters can help carry your daypack for ~$20 (or 50,000 UGX).",
    "Photography allowed—no flash near gorillas.",
    "Expect varying terrain—long pants and gloves recommended for trekking.",
    "Equator stop offers photo ops and souvenir shopping.",
  ],
  optionalAddons: [
    { name: "Quad Biking (Jinja)", availableOnRequest: true },
    { name: "Bungee Jumping (Jinja)", availableOnRequest: true },
    { name: "Horseback Safari (Jinja)", availableOnRequest: true },
  ],
  seasonalPricing: [],
  childPolicy: {
    ageRange: "Not specified",
    discount: null,
  },
  image: safariThumb, // Replace with actual image reference
},
{
  id: 9,
  title: "10 Nights PRIMATES and Ocean Beach Safaris",
  typeOfSafari: [
    "Primates",
    "Gorilla Trekking",
    "Chimpanzee Tracking",
    "Game Drives",
    "Boat Safari",
    "Beach Relaxation"
  ],
  startLocation: "Entebbe, Uganda",
  endLocation: "Entebbe, Uganda",
  price: {
    original: 4800,
    discounted: null,
    currency: "USD"
  },
  description:
    "This signature 11-day safari combines thrilling primate tracking in Uganda with relaxing days on Zanzibar’s stunning beaches. Track gorillas, chimpanzees, and explore diverse national parks before flying to the Indian Ocean for beach time.",
  countries: ["Uganda", "Tanzania"],
  itinerary: [
    {
      day: 1,
      location: "Entebbe / Kampala",
      activity: "Arrival in Uganda",
      accommodation: {
        upmarket: "Kampala Skyz Hotel by Marriot",
        midrange: "Onomo Hotel",
        budget: "SS Hotel"
      },
      mealPlan: "Half Board",
      details:
        "Meet and greet at the airport. Transfer to hotel for briefing and relaxation after your flight."
    },
    {
      day: 2,
      location: "Kibale Forest National Park",
      activity: "Drive to Kibale Forest & Bigodi Wetland Walk",
      accommodation: {
        upmarket: "Chimpanzee Nest Lodge",
        midrange: "Chimpundu Lodge",
        budget: "Chimpanzee Guest House"
      },
      mealPlan: "Full Board",
      details:
        "Scenic drive to Kibale Forest, famous for its 13 primate species. In the evening, explore Bigodi Wetland Sanctuary."
    },
    {
      day: 3,
      location: "Queen Elizabeth National Park",
      activity: "Chimpanzee tracking & boat ride on Kazinga Channel",
      accommodation: {
        upmarket: "Elephant Plains Lodge",
        midrange: "Kikorongo Safari Lodge",
        budget: "Mwenyenyange Caves Lodge"
      },
      mealPlan: "Full Board",
      details:
        "Track chimpanzees in Kibale, then transfer to Queen Elizabeth NP. Enjoy a boat safari on the Kazinga Channel."
    },
    {
      day: 4,
      location: "Bwindi Impenetrable Forest",
      activity: "Drive via Ishasha sector for tree-climbing lions",
      accommodation: {
        upmarket: "Bakiga Safari Lodge",
        midrange: "Ruhija Safari Lodge",
        budget: "Broadbill Forest Camp"
      },
      mealPlan: "Full Board",
      details:
        "Drive through Ishasha sector to Bwindi. Look out for tree-climbing lions and stunning forest views."
    },
    {
      day: 5,
      location: "Bwindi / Lake Bunyonyi",
      activity: "Gorilla trekking and transfer to Lake Bunyonyi",
      accommodation: {
        upmarket: "Arcadia Safari Lodge",
        midrange: "Keije Bunyonyi Resort",
        budget: "Bunyonyi Eco Resort"
      },
      mealPlan: "Full Board",
      details:
        "Trek into Bwindi to meet mountain gorillas. Afterward, head to Lake Bunyonyi for relaxation."
    },
    {
      day: 6,
      location: "Kampala / Entebbe",
      activity: "Drive back via Igongo Cultural Center & Equator",
      accommodation: {
        upmarket: "Kampala Skyz Hotel by Marriot",
        midrange: "Onomo Hotel",
        budget: "SS Hotel"
      },
      mealPlan: "Full Board",
      details:
        "Return to Kampala, stopping at the Igongo Cultural Center and Equator for photos and souvenirs."
    },
    {
      day: 7,
      location: "Zanzibar / Tanzania",
      activity: "Flight to Zanzibar & check in at beach hotel",
      accommodation: {
        upmarket: "BlueBay Beach Resort",
        midrange: "Neptune Pwani Beach Resort",
        budget: "Miramont Resort"
      },
      mealPlan: "Full Board",
      details:
        "Fly to Zanzibar and check into your beach hotel for ocean views and coastal breezes."
    },
    {
      day: 8,
      location: "Zanzibar",
      activity: "Beach day / optional water sports",
      accommodation: "Same as Day 7",
      mealPlan: "Full Board",
      details:
        "Relax at the beach or enjoy optional water sports (extra cost). Try sunset cocktails or hotel hopping."
    },
    {
      day: 9,
      location: "Zanzibar",
      activity: "Free day for relaxation or excursions",
      accommodation: "Same as Day 7",
      mealPlan: "Full Board",
      details:
        "Unwind at the beach or explore the island further. Optional activities include snorkeling, spice tours, or boat trips."
    },
    {
      day: 10,
      location: "Zanzibar",
      activity: "Beach leisure or spa day",
      accommodation: "Same as Day 7",
      mealPlan: "Full Board",
      details:
        "Final full day in Zanzibar to relax. Enjoy spa treatments or a romantic beach walk."
    },
    {
      day: 11,
      location: "Zanzibar / Entebbe",
      activity: "Fly to Entebbe and connect to international flight",
      accommodation: null,
      mealPlan: "Breakfast",
      details:
        "After breakfast, fly to Entebbe to connect with your international flight back home."
    }
  ],
  includes: [
    "Park entry fees (Queen Elizabeth, Kibale, Bwindi)",
    "Gorilla & chimpanzee permits",
    "Game drives",
    "Boat safaris",
    "Accommodation (full board)",
    "English-speaking guide",
    "Ground transportation",
    "Airport transfers (if departing on safari end date)",
    "Internal flights (subject to season & availability)"
  ],
  excludes: [
    "International flights",
    "Visa fees",
    "Travel insurance",
    "Tips & personal expenses",
    "Optional activities (e.g. water sports in Zanzibar)",
    "Covid-19 tests or health-related costs"
  ],
  notes: [
    "Gorilla and chimp trekking require moderate fitness.",
    "All internal flights are subject to availability and seasonality.",
    "Beach hotels may be substituted depending on availability."
  ],
  optionalAddons: [],
  seasonalPricing: [],
  childPolicy: {
    ageRange: "Not specified",
    discount: null
  },
  image: safariThumb// Replace with actual image import
},
{
  id: 12,
  title: "13 Days Uganda Nile, Primates & Mombasa Beach Safari",
  typeOfSafari: [
    "Nile Exploration",
    "Game Drives",
    "Boat Safari",
    "Chimpanzee Tracking",
    "Gorilla Trekking",
    "Cultural Encounters",
    "Beach Relaxation"
  ],
  startLocation: "Entebbe, Uganda",
  endLocation: "Entebbe, Uganda",
  price: {
    original: null, // add e.g. 5200 if known
    discounted: null,
    currency: "USD"
  },
  description:
    "This 13-day safari combines Uganda’s natural wonders with relaxation on Kenya’s coast. Explore the Nile, Murchison Falls, Queen Elizabeth NP, track chimps and gorillas, then fly to Mombasa for stunning beaches at Bamburi and Diani.",
  countries: ["Uganda", "Kenya"],
  itinerary: [
    {
      day: 1,
      location: "Entebbe / Kampala",
      activity: "Arrival and transfer to hotel",
      accommodation: {
        upmarket: "Skyz Hotel by Marriot",
        midrange: "Onomo Hotel",
        budget: "Koki Hotel"
      },
      mealPlan: "Half Board",
      details:
        "Meet & greet at Entebbe Airport. Transfer to Kampala hotel for briefing and relaxation."
    },
    {
      day: 2,
      location: "Jinja – Source of the Nile",
      activity: "Boat ride to Nile source, optional rafting/bungee",
      accommodation: {
        upmarket: "Skyz Hotel by Marriot",
        midrange: "Onomo Hotel",
        budget: "Koki Hotel"
      },
      mealPlan: "Full Board",
      details:
        "Visit the cradle of the Nile at Jinja. Optional white-water rafting and bungee jumping (extra cost). Evening cultural show at Ndere Centre."
    },
    {
      day: 3,
      location: "Murchison Falls NP",
      activity: "Drive to Murchison Falls, visit Top of the Falls",
      accommodation: {
        upmarket: "Chobe Safari Lodge",
        midrange: "Tilenga Safari Lodge",
        budget: "Pakuba Safari Lodge"
      },
      mealPlan: "Full Board",
      details:
        "Scenic drive north. Visit the Top of the Falls where the Nile squeezes through a narrow gorge. Evening game drive."
    },
    {
      day: 4,
      location: "Murchison Falls NP",
      activity: "Boat ride on the Nile & Delta exploration",
      accommodation: "Same as Day 3",
      mealPlan: "Full Board",
      details:
        "Morning boat safari to the base of the falls. Afternoon excursion to the Nile-Albert Delta with birdwatching and wildlife spotting."
    },
    {
      day: 5,
      location: "Queen Elizabeth NP",
      activity: "Drive or optional flight to Queen Elizabeth NP",
      accommodation: {
        upmarket: "Mweya Safari Lodge",
        midrange: "Kikorongo Safari Lodge",
        budget: "Simba Safari Camp"
      },
      mealPlan: "Full Board",
      details:
        "7-hour scenic drive through Hoima and Kasese or fly from Pakuba Airstrip (extra cost)."
    },
    {
      day: 6,
      location: "Kalinzu Forest → Bwindi NP",
      activity: "Chimpanzee tracking & transfer to Bwindi",
      accommodation: {
        upmarket: "Gorilla Forest Camp",
        midrange: "Ruhija Safari Lodge",
        budget: "Broadbill Forest Camp"
      },
      mealPlan: "Full Board",
      details:
        "Morning chimpanzee trek in Kalinzu Forest. Drive via Ishasha sector (tree-climbing lions) en route to Bwindi."
    },
    {
      day: 7,
      location: "Bwindi Impenetrable NP",
      activity: "Gorilla trekking adventure",
      accommodation: "Same as Day 6",
      mealPlan: "Full Board",
      details:
        "Early morning gorilla trekking experience. One magical hour with the gentle giants. Afternoon at leisure or cultural walk."
    },
    {
      day: 8,
      location: "Lake Bunyonyi",
      activity: "Drive to Lake Bunyonyi via Kabale",
      accommodation: {
        upmarket: "Arcadia Lodge Bunyonyi",
        midrange: "Keije Bunyonyi Resort",
        budget: "Bunyonyi Eco Resort"
      },
      mealPlan: "Full Board",
      details:
        "Relax by Africa’s second-deepest lake, dotted with 29 islands. Optional boat rides and cultural visits."
    },
    {
      day: 9,
      location: "Mombasa, Kenya",
      activity: "Fly from Entebbe to Mombasa",
      accommodation: {
        upmarket: "Serena Beach Resort",
        midrange: "Neptune Hotel Bamburi",
        budget: "PrideInn Express"
      },
      mealPlan: "Full Board",
      details:
        "Fly to Kenya’s coast. Relax at your beach resort in Mombasa."
    },
    {
      day: "10–12",
      location: "Diani Beach, Kenya",
      activity: "Beach relaxation & optional water sports",
      accommodation: {
        upmarket: "Swahili Beach Resort",
        midrange: "Neptune Diani Beach Resort",
        budget: "Diani Backpackers"
      },
      mealPlan: "Full Board",
      details:
        "Relax on the white sandy beaches of Diani. Optional snorkeling, diving, or spa treatments (extra cost)."
    },
    {
      day: 13,
      location: "Mombasa → Entebbe",
      activity: "Return flight to Entebbe, end of safari",
      accommodation: null,
      mealPlan: "Breakfast",
      details:
        "Fly back to Entebbe for your onward international flight. End of trip."
    }
  ],
  includes: [
    "Park entry fees (Murchison Falls, Queen Elizabeth, Bwindi)",
    "Gorilla & chimpanzee permits",
    "Game drives & boat safaris",
    "Full board accommodation",
    "English-speaking driver/guide",
    "Ground transportation in 4x4 safari vehicle",
    "Airport transfers",
    "Internal flights (Entebbe – Mombasa – Entebbe)"
  ],
  excludes: [
    "International flights",
    "Visa fees (Uganda & Kenya)",
    "Travel insurance",
    "Tips & personal expenses",
    "Optional activities (rafting, bungee, water sports)",
    "Covid-19 tests or health-related expenses"
  ],
  notes: [
    "Gorilla trekking requires moderate fitness.",
    "All internal flights are subject to availability.",
    "Accommodation may be substituted depending on seasonality."
  ],
  optionalAddons: [],
  seasonalPricing: [],
  childPolicy: {
    ageRange: "Not specified",
    discount: null
  },
  image: safariThumb // Replace with your actual image import
},
{
  id: 10,
  title: "Namibia Sossusvlei Escape",
  typeOfSafari: [
    "Desert Safari",
    "Scenic Landscapes",
    "Nature",
    "Photography",
    "Private 4x4",
    "Short Escape",
  ],
  destination: "Namibia",
  countries: ["Namibia"],
  startLocation: "Windhoek, Namibia",
  endLocation: "Windhoek, Namibia",
  durationLabel: "3 Days / 2 Nights",
  minimumGuests: 2,
  accommodationSummary: "Namib Desert Lodge or similar",
  mealPlanSummary: "Daily breakfast and dinner",
  transport: "Private 4x4 Toyota Fortuner",
  description:
    "Experience Namibia's oldest desert on a short escape to Sossusvlei, Deadvlei, and Sesriem Canyon, with comfortable lodge stays and peaceful Namib Desert sunsets.",
  highlights: [
    "Explore the towering red dunes of Sossusvlei",
    "Visit the white clay pan and ancient trees of Deadvlei",
    "Discover the natural gorge of Sesriem Canyon",
    "Travel privately from Windhoek in a 4x4 vehicle",
  ],
  itinerary: [
    {
      day: 1,
      location: "Windhoek to Sossusvlei Area",
      activity: "Journey into the dunes",
      accommodation: "Namib Desert Lodge or similar",
      mealPlan: "Dinner",
      details:
        "Depart Windhoek and travel through scenic Namibian landscapes towards the Sossusvlei region. Check in at Namib Desert Lodge or similar, relax in the desert surroundings, and enjoy dinner with a spectacular sunset.",
    },
    {
      day: 2,
      location: "Sossusvlei, Deadvlei and Sesriem Canyon",
      activity: "Desert wonders excursion",
      accommodation: "Namib Desert Lodge or similar",
      mealPlan: "Breakfast, Dinner",
      details:
        "After breakfast, depart early for Sossusvlei. Explore the red dunes, visit the unique white clay pan of Deadvlei, and discover Sesriem Canyon before returning to the lodge for relaxation.",
    },
    {
      day: 3,
      location: "Sossusvlei Area to Windhoek",
      activity: "Farewell Namibia",
      accommodation: null,
      mealPlan: "Breakfast",
      details:
        "Enjoy breakfast before departing back to Windhoek, concluding your unforgettable Namib Desert adventure.",
    },
  ],
  includes: [
    "2 nights accommodation",
    "Namib Desert Lodge or similar for 2 nights",
    "Daily breakfast",
    "Daily dinner",
    "Private 4x4 Toyota Fortuner vehicle",
    "Professional driver/guide",
    "Fuel",
    "Park fees",
    "Sossusvlei excursion",
    "Deadvlei visit",
    "Sesriem Canyon visit",
  ],
  excludes: [
    "Flights",
    "Lunches",
    "Dinners not specified",
    "Optional activities",
    "Personal expenses",
    "Travel insurance",
  ],
  notes: [
    "Price is based on a minimum of 2 guests travelling together.",
    "Accommodation is based on 2 guests sharing a room.",
    "Accommodation may be replaced with a similar standard property depending on availability.",
    "Rates are subject to availability and confirmation at the time of booking.",
  ],
  optionalAddons: [],
  seasonalPricing: [],
  childPolicy: {
    ageRange: "Not specified",
    discount: null,
  },
  image: heinoThumb,
},
{
  id: 11,
  title: "Namibia Desert & Coastal Getaway",
  typeOfSafari: [
    "Desert Adventure",
    "Coastal Escape",
    "City Tour",
    "Quad Biking",
    "Camel Ride",
    "Private Tour",
  ],
  destination: "Namibia",
  countries: ["Namibia"],
  startLocation: "Hosea Kutako International Airport",
  endLocation: "Hosea Kutako International Airport",
  durationLabel: "6 Days / 5 Nights",
  minimumGuests: 2,
  accommodationSummary:
    "Hilton Garden Inn Windhoek and Swakopmund Plaza Hotel or similar",
  mealPlanSummary: "Daily breakfast",
  transport: "4x4 Toyota Fortuner",
  description:
    "Blend Windhoek's city culture, Swakopmund's Atlantic charm, Walvis Bay wetlands, and desert adventure activities in one compact Namibia getaway.",
  highlights: [
    "Guided Windhoek City Tour with iconic landmarks and craft markets",
    "Relax in Swakopmund along the Atlantic Ocean promenade",
    "Explore Walvis Bay lagoon, salt works, harbour, and waterfront",
    "Enjoy quad biking and a camel ride in the Namib Desert",
  ],
  itinerary: [
    {
      day: 1,
      location: "Windhoek",
      activity: "Welcome to Namibia and Windhoek City Tour",
      accommodation: "Hilton Garden Inn Windhoek or similar",
      mealPlan: "Breakfast",
      details:
        "Arrive at Hosea Kutako International Airport, meet your guide, and transfer to Hilton Garden Inn Windhoek. After time to relax, enjoy a guided Windhoek City Tour including Christuskirche, Parliament Gardens, Independence Memorial Museum, and local craft markets.",
    },
    {
      day: 2,
      location: "Windhoek to Swakopmund",
      activity: "Scenic drive to the coast",
      accommodation: "Swakopmund Plaza Hotel or similar",
      mealPlan: "Breakfast",
      details:
        "Travel from Windhoek to Swakopmund as rolling hills turn into desert plains. Check in, enjoy lunch, and spend the afternoon at leisure along the town streets, souvenir shops, cafes, or Atlantic promenade.",
    },
    {
      day: 3,
      location: "Walvis Bay",
      activity: "Walvis Bay City Tour",
      accommodation: "Swakopmund Plaza Hotel or similar",
      mealPlan: "Breakfast",
      details:
        "Visit the harbour town of Walvis Bay for a guided city tour covering the lagoon, salt works, harbour area, and waterfront. Look out for flamingos and birdlife before returning to Swakopmund for an evening at leisure.",
    },
    {
      day: 4,
      location: "Namib Desert near Swakopmund",
      activity: "Quad Bike Adventure and Camel Ride",
      accommodation: "Swakopmund Plaza Hotel or similar",
      mealPlan: "Breakfast",
      details:
        "Prepare for an active desert day. Ride quad bikes across magnificent dunes, then enjoy a camel ride for a slower view of the desert and photo opportunities. Return to Swakopmund for a free afternoon.",
    },
    {
      day: 5,
      location: "Swakopmund to Windhoek",
      activity: "Return to Windhoek and farewell dinner",
      accommodation: "Hilton Garden Inn Windhoek or similar",
      mealPlan: "Breakfast",
      details:
        "Check out after breakfast and travel back to Windhoek. Spend the afternoon at leisure for rooftop views, shopping, or nearby attractions before a farewell dinner celebrating the Namibian adventure.",
    },
    {
      day: 6,
      location: "Windhoek",
      activity: "Departure transfer",
      accommodation: null,
      mealPlan: "Breakfast",
      details:
        "Enjoy breakfast before checking out. Depending on your flight schedule, transfer to Hosea Kutako International Airport for departure.",
    },
  ],
  includes: [
    "Accommodation for 5 nights",
    "Daily breakfast",
    "Airport transfers",
    "Windhoek City Tour",
    "Walvis Bay City Tour",
    "Quad Bike Adventure",
    "Camel Ride",
    "4x4 Toyota Fortuner",
  ],
  excludes: [
    "International and domestic flights",
    "Visa fees where applicable",
    "Travel and medical insurance",
    "Lunches and dinners unless otherwise stated",
    "Drinks and beverages",
    "Personal expenses",
    "Optional activities not mentioned in the itinerary",
  ],
  notes: [
    "Package is based on 2 guests.",
    "Lunches and dinners are on own account unless stated in the final quote.",
    "Activities are subject to weather, availability, and local operator confirmation.",
  ],
  optionalAddons: [],
  seasonalPricing: [],
  childPolicy: {
    ageRange: "Not specified",
    discount: null,
  },
  image: beachThumb,
},
{
  id: 13,
  title: "Namibia Desert, Culture & Coast Adventure",
  typeOfSafari: [
    "Cultural Encounters",
    "Desert Safari",
    "Coastal Adventure",
    "Catamaran Cruise",
    "Sandwich Harbour",
    "Photography",
  ],
  destination: "Namibia",
  countries: ["Namibia"],
  startLocation: "Hosea Kutako International Airport",
  endLocation: "Hosea Kutako International Airport",
  durationLabel: "7 Days / 6 Nights",
  minimumGuests: 2,
  accommodationSummary:
    "Garden Inn Windhoek, Spitzkoppe tented camp, Prost Hotel Swakopmund, and Namib Desert Lodge or similar",
  mealPlanSummary: "Daily breakfast",
  transport: "4x4 Toyota Fortuner",
  description:
    "Discover Namibia's culture, coast, and desert landscapes through Himba and San village visits, Swakopmund, Walvis Bay, Sandwich Harbour, Deadvlei, Big Daddy Dune, and Sesriem Canyon.",
  highlights: [
    "Meet Himba and Bushman (San) communities near Spitzkoppe",
    "Cruise Walvis Bay by luxury catamaran",
    "Explore Sandwich Harbour where desert dunes meet the Atlantic",
    "Visit Deadvlei, Big Daddy Dune, and Sesriem Canyon",
  ],
  itinerary: [
    {
      day: 1,
      location: "Windhoek",
      activity: "Arrival in Namibia",
      accommodation: "Garden Inn Windhoek or similar",
      mealPlan: "Breakfast",
      details:
        "Arrive at Hosea Kutako International Airport, meet your guide, and transfer to Garden Inn Windhoek. Settle in after your journey and enjoy the remainder of the afternoon at leisure.",
    },
    {
      day: 2,
      location: "Windhoek to Spitzkoppe",
      activity: "Cultural encounters",
      accommodation: "Spitzkoppe tented camp or similar",
      mealPlan: "Breakfast",
      details:
        "Travel to the granite mountains of Spitzkoppe. Visit a traditional Himba Village to learn about customs and daily life, then continue to a Bushman (San) Village for insight into ancient survival skills, storytelling, and medicinal plants.",
    },
    {
      day: 3,
      location: "Spitzkoppe to Swakopmund",
      activity: "Coastal charm",
      accommodation: "Prost Hotel Swakopmund or similar",
      mealPlan: "Breakfast",
      details:
        "Drive from dramatic desert landscapes to the Atlantic coastline. Check in at Prost Hotel Swakopmund and spend the afternoon exploring colonial architecture, souvenir shops, cafes, and the beachfront promenade.",
    },
    {
      day: 4,
      location: "Walvis Bay",
      activity: "Walvis Bay City Tour",
      accommodation: "Prost Hotel Swakopmund or similar",
      mealPlan: "Breakfast",
      details:
        "Travel to Walvis Bay for a guided tour of the waterfront, lagoon, harbour, and marine environment. Look for flamingos, pelicans, and migratory birds before returning to Swakopmund for an evening at leisure.",
    },
    {
      day: 5,
      location: "Walvis Bay and Sandwich Harbour",
      activity: "Catamaran Cruise and Sandwich Harbour 4x4 Excursion",
      accommodation: "Prost Hotel Swakopmund or similar",
      mealPlan: "Breakfast",
      details:
        "Cruise across Walvis Bay by luxury catamaran with chances to see dolphins, Cape fur seals, pelicans, and seasonal whales. Continue by 4x4 to Sandwich Harbour for dune driving, viewpoints, and landscapes where the Namib Desert meets the Atlantic Ocean.",
    },
    {
      day: 6,
      location: "Swakopmund to Namib Desert",
      activity: "Solitaire stop and desert lodge stay",
      accommodation: "Namib Desert Lodge or similar",
      mealPlan: "Breakfast",
      details:
        "Depart for the Namib Desert, stopping at Solitaire for refreshments and its famous apple pie. Continue through desert landscapes to Namib Desert Lodge and enjoy a peaceful evening under star-filled skies.",
    },
    {
      day: 7,
      location: "Deadvlei, Big Daddy Dune and Sesriem Canyon",
      activity: "Final desert adventure and departure",
      accommodation: null,
      mealPlan: "Breakfast",
      details:
        "Rise early for sunrise over the Namib Desert. Explore Deadvlei, climb Big Daddy Dune if you wish, and visit Sesriem Canyon before returning to the airport for departure.",
    },
  ],
  includes: [
    "Accommodation in hotels and lodges",
    "Daily breakfast",
    "Airport meet and greet with return transfers",
    "4x4 Toyota Fortuner vehicle",
    "Himba Village experience",
    "Bushman (San) Village experience",
    "Walvis Bay City Tour",
    "Luxury Catamaran Cruise",
    "Sandwich Harbour 4x4 Excursion",
  ],
  excludes: [
    "International and domestic flights",
    "Visa fees where applicable",
    "Travel and medical insurance",
    "Lunches and dinners unless otherwise stated",
    "Drinks and beverages",
    "Personal expenses",
    "Optional activities not mentioned in the itinerary",
  ],
  notes: [
    "Package is based on 2 guests.",
    "Marine sightings are seasonal and cannot be guaranteed.",
    "Accommodation may be substituted with a similar standard property depending on availability.",
  ],
  optionalAddons: [],
  seasonalPricing: [],
  childPolicy: {
    ageRange: "Not specified",
    discount: null,
  },
  image: slavaThumb,
},


];
